<div [className]="commonService.chatExist? 'app-container' : 'app-container-wo'" id="home">
    <!-- <div class="support-banner">
        Thanks for reaching out to Outlive Chat. Peer supporters are unavailable on 15th Aug 2026, as our team is on leave. Please see the <a href="https://share.google/3FtSfaZ9yWbmeyfvy">Resources</a> section for other support services.
    </div> -->
    <div class="lang-select flex-column">
        <!-- <img [src]="selectedLanguage == 'English'? commonService.resource.image.en_icon : selectedLanguage == 'हिन्दी'? commonService.resource.image.hi_icon: commonService.resource.image.ma_icon " alt="" class="language-icon"> -->
        <div id="language" (click)="toggleLanguage()">
            <span class="selected-lang"> {{selectedLanguage}}</span>
            <img [ngClass]="{'lang-show': showLanguage, 'lang-hide': !showLanguage}" class="lang-arrow" [src]="commonService.resource.image.left_arrow" alt="" srcset="">
        </div>
        <div class="lang-option-container" *ngIf="showLanguage" id="language-container">
            <ng-container *ngFor="let option of availableLanguage(commonService.resource.language);let i=index">
                <div class="lang-content" [ngClass]="{'pb-0' : i < 1}" *ngIf="option!=selectedLanguage">
                    {{option}}
                    <div class="lang-divider" *ngIf="i < 1" id="sep-line"></div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="content-container">
        <div class="row m-0">
            <div class="col-md-2 p-0"></div>
            <div class="col-sm-12 col-md-3 ps-0 pe-5">
                <div class="">
                    <div class="app-heading d-block" [innerHTML]="('home.title' | translate)" *ngIf="commonService.current.page == 'HOME'">
                    </div>
                    <div class="app-heading d-block" [innerHTML]="('home.transfer.title' | translate)" *ngIf="commonService.current.page == 'TRANSFER-HOME'">
                    </div>
                    <div class="app-content-body" *ngIf="commonService.current.page == 'HOME'">
                        <span *ngIf="!commonService.chatExist">{{ 'home.subContentBeforeChat' | translate}}</span>
                        <span *ngIf="commonService.chatExist">{{ 'home.subContentAfterChat' | translate}}</span>
                    </div>
                    <div class="app-content-body" *ngIf="commonService.current.page == 'TRANSFER-HOME'">
                        <span>{{ 'home.transfer.subContent' | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-5 p-0 position-relative">
                <div class="content-container-frame">
                    <div class="pe-2" *ngIf="!commonService.chatExist">
                        <div class="app-sub-heading mb-4 d-flex justify-content-between">
                            {{ 'home.subHeadingBeforeChat' | translate}}
                            <span class="material-icons-outlined cursor" [ngClass]="{'refresh-start': !apiLoaded}" style="margin: 0 -0.5rem 0 0;" (click)="getAvailablePeers()">
                            refresh
                            </span>
                        </div>
                        <div class="content-container-overflow">
                            <div class="all-busy-banner mb-3" *ngIf="allPeersBusy() && apiLoaded" [innerHTML]="'home.allPeersBusyMessage' | translate"></div>
                            <ng-container *ngFor="let user of userList; let i=index">
                                <div class="pb-3 d-flex align-items-center justify-content-between"
                                    [class.cursor]="!user.is_busy"
                                    [class.busy-peer]="user.is_busy"
                                    (click)="!user.is_busy && showDetails(i)"
                                    *ngIf="commonService.availableClient.includes(user.peerId) && apiLoaded">
                                    <div class="d-flex gap-3">
                                        <img [src]="commonService.resource.image.user_icon" alt="User">
                                        <div class="text-capitalize">
                                            <div class="home-user-name">{{user.displayName}}</div>
                                            <div class="home-user-details">
                                                <span *ngIf="user.age">{{user.age}}</span> <span *ngIf="user.age && (user.gender || user.sexuality)">{{ ','}}&nbsp;</span><span *ngIf="user.gender"> {{user.gender}}</span>
                                                <span *ngIf="user.gender && user.sexuality">{{ ','}}&nbsp;</span><span *ngIf="user.sexuality"> {{user.sexuality}}</span>
                                            </div>
                                            <div class="mt-1" *ngIf="user.languages && user.languages.length">
                                                <span class="languages me-1" *ngFor="let lang of user.languages">{{lang}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <span *ngIf="user.is_busy" class="busy-pill">{{ 'home.busy' | translate }}</span>
                                        <img *ngIf="!user.is_busy" [src]="commonService.resource.image.right_arrow" alt="">
                                    </div>
                                </div>
                            </ng-container>
                            <div class="app-content-body p-0 " *ngIf="!commonService.availableClient.length && apiLoaded ">
                                <span *ngIf="!isServiceOpen" [innerHTML]="'home.chatClosedMessage' | translate"></span>
                                <span *ngIf="isServiceOpen">{{'home.noPeerMessage' | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class=" " *ngIf="commonService.chatExist ">
                        <div class="app-sub-heading mb-4 ">
                            <span *ngIf="!commonService.chatTransferred">
                                {{ 'home.subHeadingAfterChat' | translate}}
                            </span>
                            <span *ngIf="commonService.chatTransferred">
                                {{ 'home.transferred.title' | translate}}
                            </span>
                        </div>
                        <div class="pb-3 pe-2 content-container-overflow ">
                            <div class="peer-select-container bg-white m-0 ">
                                <div class="peer-select-name pb-2 text-capitalize ">
                                    {{commonService.peerDetails.displayName}}
                                </div>
                                <div class="app-sub-content pb-2 ">
                                    <span>{{commonService.peerDetails.age}}</span>
                                    <span *ngIf="commonService.peerDetails.age && (commonService.peerDetails.gender || commonService.peerDetails.sexuality)">{{ ','}}&nbsp;</span>
                                    <span *ngIf="commonService.peerDetails.gender"> {{ commonService.peerDetails.gender}}</span>
                                    <span *ngIf="commonService.peerDetails.gender && commonService.peerDetails.sexuality">{{ ','}}&nbsp;</span>
                                    <span *ngIf="commonService.peerDetails.sexuality">{{ commonService.peerDetails.sexuality}}</span>
                                </div>
                                <div class="pb-3 ">
                                    <span class="languages me-2 ">{{commonService.peerDetails.languages.join(', ')}}</span>
                                    <span class="city ">{{ commonService.peerDetails.city}}</span>
                                </div>
                                <div class="peer-select-definition ">{{'home.peerDefineContent' | translate}}</div>
                                <img class="peer-select-vector " [src]="commonService.resource.image.peer_white_vector " alt=" ">
                            </div>
                            <div class="d-flex gap-3 mt-5 " *ngIf="commonService.chatExist ">
                                <button mat-button class="primary-button w-60 bg-white " (click)="showChat() ">
                                    {{ 'home.showChat' | translate}}
                                </button>
                                <button mat-button class="primary-button w-40 text-white bg-black " (click)="endChat() ">
                                    {{ 'home.endChat' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 p-0 "></div>
            </div>
        </div>
    </div>
    <div class="progress-message " *ngIf="[ 'CONNECTING'].includes(commonService.current.status) ">
        <div class="row m-0 ">
            <div class="col-md-2 mobile-hide p-0 "></div>
            <div class="col-md-3 mobile-hide p-0 "></div>
            <div class="col-md-5 col-sm-12 p-0 card progress-message-box p-3 ">
                <div class="d-flex justify-content-between app-content-body p-0 ">
                    <span>{{'home.connecting.title' | translate}}</span>
                    <div class="d-flex " (click)="app.modal.show() ">
                        show
                        <span class="material-icons ">
                            keyboard_arrow_up
                            </span>
                    </div>
                </div>
            </div>
            <div class="col-md-2 p-0 ">
            </div>
        </div>
    </div>
</div>
